<template>
  <div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input style="width: 20rem;" v-model="dataForm.keyword" placeholder="请输入要搜索的内容" clearable
                  suffix-icon="el-icon-search">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getAdminList()">搜索</el-button>
      </el-form-item>
      <el-form-item style="float: right;" v-if="uuid != 1">
        <el-button type="primary" @click="addAdminClick()">添加</el-button>
      </el-form-item>
    </el-form>
    <!-- v-if="operations.includes('新增管理员')" -->
    <!-- <el-input placeholder="请输入管理员姓名" v-model="keyword_search" clearable class="input">
    </el-input> -->
    <!-- <el-button type="primary" class="searchBtn" @click="getAdminList">筛选</el-button> -->
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="ID" width="60" align="center" :index="handlerSerial">
        </el-table-column>
        <el-table-column prop="nickname" label="管理员姓名" align="center">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号码" align="center">
        </el-table-column>
        <el-table-column prop="group_title" label="角色" align="center">
          <template slot-scope="scope">
            {{scope.row.authGroup.name}}
          </template>
        </el-table-column>
        <el-table-column prop="last_login" label="最后登陆时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="operation-item" @click="editAdminClick(scope.row)">编辑</span>
              <!-- v-if="operations.includes('编辑管理员')" -->
              <span class="danger operation-item" @click="deleteAdminClick(scope.row)">删除</span>
              <!-- v-if="operations.includes('删除管理员')" -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange"
                         @page-change="handlePageChange"></common-pagination>
    </div>
    <common-dialog :title="dialogTitle" :dialogVisible="dialogVisible" @cancel="dialogCancelClick"
                   @confirm="dialogConfirmClick" @dialog-close="dialogClose">
      <div class="dialog-body-wrap">
        <!-- <div v-if="dialogType === 'add' || dialogType === 'edit' ">

        </div> -->
        <div v-if="dialogType ==='delete'">
          是否删除管理员？
        </div>
      </div>
    </common-dialog>
    <edit-dialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog" @confirm="confirmDialog">
    </edit-dialog>
  </div>
</template>

<script>
import CommonPagination from "@/components/CommonPagination";
import CommonDialog from "@/components/CommonDialog";
import EditDialog from "./components/editdialog";
import {
  getAuthList,
  identityOf,
  addAdminUser,
  editAuthUser,
  delAuthUser
} from "@/api/auth";
import {
  mapState
} from "vuex";
import operations from "@/mixins/operations";
import utils from "@/jslibs/utils";

export default {
  mixins: [operations],
  data() {
    return {
      uuid:'',
      dataForm: {},
      tableData: [],
      page_size: 10,
      page_index: 1,
      total: 100, //总条数
      dialogVisible: false,
      editdialogVisible: false,
      dialogTitle: "",
      dialogType: "",
      handle_row: {},
      three_rules: [],
      selectForm: {},
      keyword_search: ""
    };
  },
  components: {
    CommonPagination,
    CommonDialog,
    EditDialog
  },
  computed: {
    ...mapState(["operationList"])
  },
  mounted() {
    this.getAdminList();
  },
  methods: {
    async getAdminList() {
      let postData = {
        status: 1,
        page_size: this.page_size,
        page_index: this.page_index,
        account: this.dataForm.keyword
      };
      const {
        status,
        data
      } = await getAuthList(postData);
      if (status !== 200) return;
      this.tableData = data.result.data;
      this.total = data.result.total;
    },
    addAdminClick() {
      //this.$router.push("/add-admin");
      this.selectForm = {};
      this.editdialogVisible = true;
    },
    editAdminClick(row) {
      this.editdialogVisible = true;
      this.selectForm = row;
      // this.$router.push({
      //   path: "/edit-admin",
      //   query: {
      //     uuid: row.uuid
      //   }
      // });
    },
    closeDialog(row) {
      this.editdialogVisible = row;
      //this.getAdminList()
    },
    confirmDialog(row) {
      this.editdialogVisible = row;
      this.getAdminList()
    },
    deleteAdminClick(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.dialogType = "delete";
      this.dialogTitle = "删除管理员";
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this.getAdminList();
    },
    handlePageChange(page) {
      this.page_index = page;
      this.getAdminList();
    },
    handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    async dialogConfirmClick() {
      if (this.dialogType === "delete") {
        const {
          status
        } = await delAuthUser({
          admin_id:this.form.admin_id
        });
        if (status === 200) {
          this.dialogVisible = false;
          return;
        }
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.checked = false;
      this.form = {};
      this.getAdminList();
    },
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations;
        }
      });
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf("添加") !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf("删除") !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf("编辑") !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
  .addBtn();
}

.input {
  width: 300px;
  margin-right: 30px;
}

.table-wrap {
  .table-wrap();
}
</style>
